import { render, staticRenderFns } from "./tabGeneralUICustomLayout.vue?vue&type=template&id=4a5534ee&"
import script from "./tabGeneralUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabGeneralUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a5534ee')) {
      api.createRecord('4a5534ee', component.options)
    } else {
      api.reload('4a5534ee', component.options)
    }
    module.hot.accept("./tabGeneralUICustomLayout.vue?vue&type=template&id=4a5534ee&", function () {
      api.rerender('4a5534ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneralUICustomLayout.vue"
export default component.exports